export default "__VITE_ASSET__BCFVFaj7__"